export enum BillingNoticeKey {
    CANCELLED =  'billing.canceled',
    PAST_DUE = 'billing.past_due',
    UNPAID = 'billing.unpaid',
    CARD_EXPIRED = 'billing.card_expired',
    CARD_NEAR_EXPIRY = 'billing.card_near_expiry',
    TRIAL = 'billing.trial',
    NO_SOURCE = 'billing.nosource',
    NEGATIVE_BALANCE = 'billing.negative_balance',
    TRIAL_EXPIRED = 'billing.trial_expired',
    PAYMENT_FAILURE = 'billing.payment_failure',
    POSITIVE_BALANCE = 'billing.positive_balance',
}
